import Vue from "vue";
import moment from "moment";

/**
 * Форматирование даты
 */
Vue.filter("formatDate", (date) => {
  return moment(date).format("DD.MM.YYYY");
});

/**
 * Форматирование цены
 */
Vue.filter("prettyPrice", (price) => {
  return Number(price).toLocaleString("ru", {
    maximumFractionDigits: 2,
  });
});

Vue.filter("image", (entity) => {
  if (entity) {
    return location.origin + entity.url;
  }
  return "/distro/images/no-image.jpg";
});

Vue.filter("image_alt", (entity) => {
  if (entity && entity.img) {
    return entity.img.alt;
  }
  return "";
});
